import api from "../../config/api";

// Serviço dedicado ao módulo FEX da SHEAI
const fex = (data: any) => {
  return api.post("/sheai/fex", data);
};

const fexStatus = (debriefingId: any) => {
  return api.get("/sheai/statusfex/debriefing/" + debriefingId);
};

const SheAiFexService = {
  fex,
  fexStatus,
};

export default SheAiFexService;
